var map = {
	"./student": [
		47882,
		7882
	],
	"./student/": [
		47882,
		7882
	],
	"./student/constants": [
		49395,
		9395
	],
	"./student/constants.ts": [
		49395,
		9395
	],
	"./student/index": [
		47882,
		7882
	],
	"./student/index.ts": [
		47882,
		7882
	],
	"./student/student": [
		59555,
		9555
	],
	"./student/student.tsx": [
		59555,
		9555
	],
	"./student/types": [
		44795,
		4795
	],
	"./student/types.ts": [
		44795,
		4795
	],
	"./student/utils": [
		14671,
		4671
	],
	"./student/utils.ts": [
		14671,
		4671
	],
	"./teacher": [
		53001,
		3001
	],
	"./teacher/": [
		53001,
		3001
	],
	"./teacher/components": [
		25340,
		5340
	],
	"./teacher/components/": [
		25340,
		5340
	],
	"./teacher/components/index": [
		25340,
		5340
	],
	"./teacher/components/index.ts": [
		25340,
		5340
	],
	"./teacher/components/solutions-table": [
		39348,
		9348
	],
	"./teacher/components/solutions-table.tsx": [
		39348,
		9348
	],
	"./teacher/index": [
		53001,
		3001
	],
	"./teacher/index.tsx": [
		53001,
		3001
	],
	"./teacher/teacher": [
		58987,
		8987
	],
	"./teacher/teacher.tsx": [
		58987,
		8987
	],
	"./teacher/utils": [
		97570
	],
	"./teacher/utils.ts": [
		97570
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87652;
module.exports = webpackAsyncContext;